import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pr-6 pl-4" }
const _hoisted_3 = { class: "pr-6" }
const _hoisted_4 = { class: "pr-6" }
const _hoisted_5 = { style: {"position":"absolute","top":"10px","right":"10px"} }
const _hoisted_6 = {
  key: 0,
  class: "memoru-media-modal"
}
const _hoisted_7 = { class: "memoru-media-modal__top" }
const _hoisted_8 = { class: "memoru-media-modal__body" }
const _hoisted_9 = {
  key: 1,
  class: "memoru-media",
  controls: ""
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "memoru-media-modal__bottom" }
const _hoisted_12 = { class: "fab-wrapper" }
const _hoisted_13 = { class: "fab-items mb-4" }
const _hoisted_14 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_15 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_16 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_17 = { class: "my-3" }
const _hoisted_18 = { class: "my-3" }
const _hoisted_19 = { class: "my-3" }
const _hoisted_20 = { class: "my-3" }
const _hoisted_21 = { class: "my-3" }
const _hoisted_22 = { class: "d-flex align-center" }
const _hoisted_23 = { class: "my-3" }
const _hoisted_24 = { class: "d-flex align-center" }
const _hoisted_25 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_26 = { class: "text-body-1" }
const _hoisted_27 = {
  key: 0,
  class: "fab-wrapper"
}
const _hoisted_28 = {
  key: 0,
  class: "bulk-delete-bar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_slide_y_reverse_transition = _resolveComponent("v-slide-y-reverse-transition")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "primary",
        flat: "",
        app: "",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            style: {"position":"absolute","left":"4px","z-index":"2"},
            to: '/'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                large: "",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_app_bar_title, { style: {"position":"absolute","left":"25px","max-width":"50vw","min-width":"fit-content","z-index":"1","pointer-events":"none"} }, {
            default: _withCtx(() => [
              (_ctx.album)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.album.title.length > 12 ? _ctx.album.title.slice(0, 12) + '…' : _ctx.album.title), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            size: "default",
            variant: "text",
            color: _ctx.bulkDelFlg ? 'error' : 'white',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.bulkDelFlg = !_ctx.bulkDelFlg)),
            class: _normalizeClass([_ctx.bulkDelFlg ? 'text-h6 mr-2' : 'me-n2']),
            style: {"z-index":"3"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createTextVNode("mdi-trash-can-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color", "class"]),
          (!_ctx.bulkDelFlg)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                size: "small",
                variant: "text",
                color: "white",
                onClick: _ctx.openAlbumEdit
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("編集", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { fluid: "" }, {
            default: _withCtx(() => [
              (_ctx.bulkDelFlg)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    class: "my-4",
                    type: "info",
                    color: "primary",
                    variant: "outlined",
                    density: "compact",
                    style: {"font-size":"0.9rem"}
                  }, {
                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                      _createTextVNode(" チェックボックスが表示されないアイテムは、購入済みのアイテムのため削除できません。 ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isFetching || _ctx.isUploading)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 1,
                    indeterminate: "",
                    color: "primary",
                    height: "3"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, { class: "pb-3 pt-3" }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", _hoisted_2, "全件：" + _toDisplayString(_ctx.photoTotal + _ctx.movieTotal), 1),
                  _createElementVNode("h3", _hoisted_3, "写真：" + _toDisplayString(_ctx.photoTotal), 1),
                  _createElementVNode("h3", _hoisted_4, "動画：" + _toDisplayString(_ctx.movieTotal), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (c, i) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: i,
                      cols: "6"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "d-flex justify-left align-center mt-8",
                          style: _normalizeStyle({ visibility: _ctx.bulkDelFlg && c.purchasedCount == 0 ? 'visible' : 'hidden' })
                        }, [
                          _createVNode(_component_v_checkbox, {
                            modelValue: _ctx.bulkDelTarget,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bulkDelTarget) = $event)),
                            value: c.multimediaId,
                            disabled: _ctx.loading,
                            "hide-details": "",
                            density: "compact",
                            class: "tight-checkbox",
                            color: "primary",
                            style: {"--v-selection-control-size":"40px","font-size":"1.5rem"}
                          }, null, 8, ["modelValue", "value", "disabled"])
                        ], 4),
                        _createVNode(_component_v_card, {
                          class: "pa-2",
                          variant: "outlined",
                          tile: "",
                          onClick: ($event: any) => (_ctx.selectMedia(c)),
                          style: {"position":"relative","color":"#f0f0f0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              src: c.thumbnailUrl ?? undefined,
                              "aspect-ratio": "1",
                              class: "pa-0"
                            }, null, 8, ["src"]),
                            _createElementVNode("span", _hoisted_5, [
                              (c.status === 'requested' || c.status === 'inProgress')
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    variant: "flat"
                                  }, {
                                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                      _createTextVNode(" 処理中 ", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (c.status === 'completed')
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 1,
                                    color: "primary",
                                    variant: "flat"
                                  }, {
                                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                      _createTextVNode(" 完了 ", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (c.status === 'failed')
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 2,
                                    color: "red",
                                    variant: "flat"
                                  }, {
                                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                      _createTextVNode(" 失敗 ", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_v_overlay, {
                "model-value": _ctx.selectedMedia !== null,
                class: "memoru-media-overlay",
                persistent: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.selectedMedia)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          (_ctx.selectedMedia.purchasedCount == 0)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                color: "red",
                                variant: "flat",
                                size: "small",
                                onClick: _cache[2] || (_cache[2] = () => _ctx.isDeleteDialogOpen = true)
                              }, {
                                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                  _createTextVNode(" 削除 ", -1)
                                ]))]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                color: "grey",
                                variant: "flat",
                                size: "small"
                              }, {
                                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                  _createTextVNode(" 購入済み ", -1)
                                ]))]),
                                _: 1
                              }))
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          (_ctx.selectedMedia.category === 'photo')
                            ? (_openBlock(), _createBlock(_component_v_img, {
                                key: 0,
                                class: "memoru-media",
                                src: _ctx.selectedMedia.previewImageUrl ?? undefined,
                                cover: false
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true),
                          (_ctx.selectedMedia.category === 'movie')
                            ? (_openBlock(), _createElementBlock("video", _hoisted_9, [
                                _createElementVNode("source", {
                                  src: _ctx.selectedMedia.previewImageUrl ?? undefined
                                }, null, 8, _hoisted_10)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_v_btn, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectMedia(null))),
                            variant: "flat",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createTextVNode(" 閉じる ", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_v_slide_y_reverse_transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              _createVNode(_component_v_btn, {
                color: "primary",
                rounded: "pill",
                size: "large",
                class: "mb-3",
                "prepend-icon": "mdi-video",
                onClick: _ctx.videoSelectClicked
              }, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                  _createTextVNode(" 動画をアップロード ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                color: "primary",
                rounded: "pill",
                size: "large",
                class: "mb-3",
                "prepend-icon": "mdi-camera",
                onClick: _ctx.imageSelectClicked
              }, {
                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                  _createTextVNode(" 画像をアップロード ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ], 512), [
              [_vShow, _ctx.isFabOpen]
            ])
          ]),
          _: 1
        }),
        (!_ctx.bulkDelFlg)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              color: "primary",
              icon: "",
              size: "x-large",
              elevation: "4",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isFabOpen = !_ctx.isFabOpen))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "large" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isFabOpen ? 'mdi-close' : 'mdi-plus'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          ref: "imageInput",
          type: "file",
          class: "hidden-input",
          accept: "image/*",
          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.imageSelected && _ctx.imageSelected(...args))),
          multiple: ""
        }, null, 544),
        _createElementVNode("input", {
          ref: "videoInput",
          type: "file",
          class: "hidden-input",
          accept: "video/*",
          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.videoSelected && _ctx.videoSelected(...args))),
          multiple: ""
        }, null, 544)
      ]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.isDeleteDialogOpen,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isDeleteDialogOpen) = $event)),
        class: "delete-absence-dialog"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_v_card_title, { class: "headline lighten-2" }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode("削除しますか？", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "white",
                      variant: "flat",
                      onClick: _cache[7] || (_cache[7] = () => (_ctx.isDeleteDialogOpen = false))
                    }, {
                      default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                        _createTextVNode(" キャンセル ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "error",
                      class: "ml-5",
                      variant: "flat",
                      onClick: _ctx.deleteMedia,
                      loading: _ctx.isDeleting
                    }, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode(" 削除 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        "model-value": _ctx.editingAlbum !== null,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = val => { if (!val) _ctx.closeAlbumEdit() }),
        class: "delete-absence-dialog"
      }, {
        default: _withCtx(() => [
          (_ctx.editingAlbum)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_v_card_title, { class: "headline lighten-2" }, {
                      default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                        _createTextVNode("アルバムを編集", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[35] || (_cache[35] = _createElementVNode("span", { class: "mb-2" }, "年度", -1)),
                        _createVNode(_component_v_text_field, {
                          type: "number",
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined",
                          modelValue: _ctx.editingAlbum.year,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editingAlbum.year) = $event)),
                          color: "primary",
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "mb-2" }, "クラス", -1)),
                        _createVNode(_component_v_select, {
                          variant: "outlined",
                          multiple: "",
                          density: "compact",
                          "hide-details": "",
                          modelValue: _ctx.editingAlbum.nurseryClasses,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editingAlbum.nurseryClasses) = $event)),
                          items: _ctx.classes,
                          "item-value": "classId",
                          "item-title": "className",
                          "return-object": "",
                          color: "primary"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[37] || (_cache[37] = _createElementVNode("span", { class: "mb-2" }, "アルバムのタイトル", -1)),
                        _createVNode(_component_v_text_field, {
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined",
                          modelValue: _ctx.editingAlbum.title,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editingAlbum.title) = $event)),
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "mb-2" }, "コメント", -1)),
                        _createVNode(_component_v_text_field, {
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined",
                          modelValue: _ctx.editingAlbum.comment,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editingAlbum.comment) = $event)),
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "mb-2" }, "公開開始日 *", -1)),
                          _createVNode(_component_v_spacer)
                        ]),
                        _createVNode(_component_v_text_field, {
                          type: "datetime-local",
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined",
                          modelValue: _ctx.editingAlbum.availableAfter,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editingAlbum.availableAfter) = $event)),
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "mb-2" }, "公開終了日", -1)),
                          _createVNode(_component_v_spacer)
                        ]),
                        _createVNode(_component_v_text_field, {
                          type: "datetime-local",
                          density: "compact",
                          "hide-details": "",
                          variant: "outlined",
                          modelValue: _ctx.editingAlbum.availableBefore,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editingAlbum.availableBefore) = $event)),
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          color: "white",
                          variant: "flat",
                          onClick: _ctx.closeAlbumEdit
                        }, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode(" キャンセル ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          class: "ml-5",
                          variant: "flat",
                          loading: _ctx.isUpdating,
                          onClick: _ctx.updateAlbum
                        }, {
                          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                            _createTextVNode(" 保存 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading", "onClick"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model-value"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.isDelDialog,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isDelDialog) = $event)),
        "max-width": "500px",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "d-flex flex-column align-center text-center px-6 pt-6 pb-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "text-orange-lighten-2 mb-2",
                    size: "72px"
                  }, {
                    default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                      _createTextVNode(" mdi-alert-circle-outline ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_26, [
                    _createTextVNode(" 選択した" + _toDisplayString(_ctx.bulkDelTarget.length) + "のアイテムを削除します。", 1),
                    _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
                    _cache[45] || (_cache[45] = _createTextVNode(" 削除後この操作は取り消せません。", -1)),
                    _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
                    _cache[47] || (_cache[47] = _createTextVNode(" 削除しますか？ ", -1))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-space-between gs-4 px-6 pb-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "outlined",
                    color: "grey-darken-1",
                    class: "px-6",
                    rounded: "md",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isDelDialog = false)),
                    loading: _ctx.loading
                  }, {
                    default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                      _createTextVNode(" キャンセル ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"]),
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    color: "error",
                    class: "px-6 text-white",
                    rounded: "md",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.bulkDeleteContentBody())),
                    loading: _ctx.loading
                  }, {
                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                      _createTextVNode(" 削除 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (!_ctx.bulkDelFlg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27))
        : _createCommentVNode("", true),
      _createVNode(_component_v_slide_y_reverse_transition, null, {
        default: _withCtx(() => [
          (_ctx.bulkDelFlg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  size: "large",
                  block: "",
                  rounded: "pill",
                  elevation: "4",
                  onClick: _ctx.bulkDeleteContent
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 一括削除 (" + _toDisplayString(_ctx.bulkDelTarget.length) + "アイテム) ", 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}